import api from '../instance';

interface ISendTicketCESData {
  i: number;
  h: string | null;
  s: number;
  c?: string;
}

type TSendTicketCESResponse = {
  ok: boolean;
};

export interface ISendTopicCESData {
  score: number;
  organization_id?: string;
  uid?: string;
}

type TSendTopicCESResponse = {
  ok: boolean;
};

export default {
  sendTicketCES: (data: ISendTicketCESData): Promise<TSendTicketCESResponse> =>
    api.post('ces', data),
  sendTopicCES: (topicSlug: string, data: ISendTopicCESData): Promise<TSendTopicCESResponse> =>
    api.post(`ces/topic/${topicSlug}`, data),
};
